import React from "react";
import logo from "../../assets/images/chart-reset-icon.svg";

const chartResetLog = props => <img src={logo} alt="ChartReset" />;

export default chartResetLog;
